import axios from 'axios';
import { API_URL } from '../../config/config';
import { EventEmitter } from 'eventemitter3';

export default class Register {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new Register();
	}

	constructor() {
		this.events = new EventEmitter;
	}

	registerAccount(user) {
		return axios.post(API_URL + "/auth/v1/register", user);
	}

	confirmEmail(token) {
		return axios.get(API_URL + "/auth/v1/confirm?token=" + token);
	}

	resetRequest(email) {
		return axios.post(API_URL + "/auth/v1/password/forgotten", { email });
	}

	resetPassword(password, token) {
		return axios.post(API_URL + "/auth/v1/password/reset", { token, password });
	}
}